import { useNavigate, Link } from 'react-router-dom'
import Header from '../components/Header'
import TERMS_INTERIM_MD from '../content/termsInterim'
import { parseTerms, withLinks } from '../lib/termsRender'

// The lawyer-approved interim Terms (7 Oct 2026), word for word — see lib/termsRender.js
export default function Terms() {
const navigate = useNavigate()
const blocks = parseTerms(TERMS_INTERIM_MD)

return (
<div>
<Header />
<div className="container" style={{ maxWidth: 700, padding: '2rem 1rem', lineHeight: 1.8 }}>
<button className="btn btn-ghost btn-sm" onClick={() => window.history.length > 1 ? navigate(-1) : window.close()} style={{ marginBottom: '1rem' }}>← Back</button>

{blocks.map((b, i) => {
if (b.type === 'h1') return <h1 key={i} style={{ fontSize: 28, fontWeight: 600, marginBottom: '2rem' }}>{withLinks(b.text)}</h1>
if (b.type === 'h2') return <h2 key={i} style={{ fontSize: 20, fontWeight: 600, margin: '2rem 0 10px', color: 'var(--navy)' }}>{withLinks(b.text)}</h2>
if (b.type === 'h3') return <h3 key={i} style={{ fontSize: 16, fontWeight: 600, margin: '1.25rem 0 6px' }}>{withLinks(b.text)}</h3>
return <p key={i} style={{ color: 'var(--text-muted)', fontSize: 14, margin: '0 0 8px' }}>{withLinks(b.text)}</p>
})}

<p style={{ fontSize: 14, margin: '2rem 0 0', paddingTop: '1rem', borderTop: '1px solid var(--border)' }}>
This Agreement includes our <Link to="/prohibited-items" style={{ color: 'var(--primary)' }}>Prohibited Items &amp; Safety Policy</Link> and <Link to="/privacy" style={{ color: 'var(--primary)' }}>Privacy Policy</Link>.
</p>
</div>
</div>
)
}
